import { render, staticRenderFns } from "./jobs-detail.vue?vue&type=template&id=4e893e08&scoped=true"
import script from "./jobs-detail.vue?vue&type=script&lang=js"
export * from "./jobs-detail.vue?vue&type=script&lang=js"
import style0 from "./jobs-detail.vue?vue&type=style&index=0&id=4e893e08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_064421c868bf9d44c080cdd6f5d40e10/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e893e08",
  null
  
)

export default component.exports